import { render, staticRenderFns } from "./ExpensesFS.vue?vue&type=template&id=6ad9ea2c&scoped=true"
import script from "./ExpensesFS.vue?vue&type=script&lang=ts"
export * from "./ExpensesFS.vue?vue&type=script&lang=ts"
import style0 from "./ExpensesFS.vue?vue&type=style&index=0&id=6ad9ea2c&prod&lang=scss"
import style1 from "./ExpensesFS.vue?vue&type=style&index=1&id=6ad9ea2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad9ea2c",
  null
  
)

export default component.exports